import { getMonthDateRange, getWeekDateRange } from '@common/utils/date';

export interface ProgrammeDateFilter {
	id: 'date-filter';
	label: string;
	filterParameter: 'date';
	parameter: ['dateFrom', 'dateTo'];
	options: ProgrammeDateFilterOption[];
}

interface ProgrammeDateFilterOption {
	id: string;
	label: string;
	filterValue: string;
	value?: Date[];
}

export const programmeDateFilter: ProgrammeDateFilter = {
	id: 'date-filter',
	label: 'When',
	filterParameter: 'date',
	parameter: ['dateFrom', 'dateTo'],
	options: [
		{
			id: 'date-filter-anytime',
			label: 'Anytime',
			filterValue: '',
			value: undefined,
		},
		{
			id: 'date-filter-this-week',
			label: 'This week',
			filterValue: 'this-week',
			value: getWeekDateRange(),
		},
		{
			id: 'date-filter-next-week',
			label: 'Next week',
			filterValue: 'next-week',
			value: getWeekDateRange(1),
		},
		{
			id: 'date-filter-this-month',
			label: 'This month',
			filterValue: 'this-month',
			value: getMonthDateRange(),
		},
		{
			id: 'date-filter-next-month',
			label: 'Next month',
			filterValue: 'next-month',
			value: getMonthDateRange(1),
		},
		{
			id: 'date-filter-further-ahead',
			label: 'Further ahead',
			filterValue: 'further-ahead',
			value: getMonthDateRange(2).slice(0, 1),
		},
	],
};
